// frontend/src/components/profile/RecentBadgesCard.tsx

import { Link } from 'react-router-dom';
import { RecentBadge } from '../../types/profile.types';

interface RecentBadgesCardProps {
  badges: RecentBadge[];
}

export function RecentBadgesCard({ badges }: RecentBadgesCardProps) {
  return (
    <div className="card">
      <h3 className="parent-section-title">Son Rozetler</h3>
      {badges.length === 0 ? (
        <p className="parent-empty-text">
          Henüz rozet kazanmadın. <Link to="/badges">Rozetleri gör →</Link>
        </p>
      ) : (
        <div className="profile-recent-badges">
          {badges.map((badge, i) => (
            <div key={i} className="profile-recent-badge-icon" title={badge.title}>
              {badge.icon}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
